module.exports = __webpack_public_path__ + "static/img/fg-02_25.a78c231.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/fg-02_25.gif
// module id = RDjR
// module chunks = 1